const assets = {
  // IMAGES
  logo: require('./images/rylyflogo.png'),
  avatar: require('./images/avatar.png'),

  //LOGOS
};

export default assets;
